export default {
    numberFormat(num) {
        return Number(num).toLocaleString();
    },
    dateFormat(datetime, format = "LLLL") {
        if (!datetime) return "";
        if (format === "LLLL") { format = "YYYY年MM月DD日(ddd) HH時mm分"; }
        else if (format === "LLL") { format = "YYYY年MM月DD日 HH:mm"; }
        else if (format === "LL") { format = "YYYY MM DD"; }
        else if (format === "L") { format = "YYYY/MM/DD"; }
        return moment(datetime).format(format);
    },
    fromNow(datetime) {
        if (!datetime) return "";
        return moment(datetime).fromNow();
    },
    wrap(string) {
        if (typeof string !== 'string') {
            return string;
        }
        string = string.replace(/[&'`"<>]/g, function(match) {
            return {
                '&': '&amp;',
                "'": '&#x27;',
                '`': '&#x60;',
                '"': '&quot;',
                '<': '&lt;',
                '>': '&gt;',
            }[match]
        });
        string = string.replace(/([\d\?!？！a-z&#%\-=^~\\;:\+\*\/\., ]+)/iug, "\t$1\t");
        let rows = string.split(/\t/);
        for (let i = 0; i < rows.length; i++) {
            if (rows[i].trim().match(/^[\d\?!？！\.,\-;:\+\*\/]{1,3}$/iu)) {
                rows[i] = "<span class='text-combine'>" + rows[i].trim() + "</span>";
            } else if (rows[i].trim().match(/^[a-z&#%\-=^~\\;:\+\*\/\.,]{1,4}$/iu)) {
                rows[i] = "<span class='text-combine'>" + rows[i].trim() + "</span>";
            }
        }
        string = rows.join("");
        rows = string.split(/\n/);
        for (let i = 0; i < rows.length; i++) {
            let m = null;
            if (rows[i].match(/^　{10,}/u)) {
                rows[i] = rows[i].replace(/^　{10,}(.+)$/u, "<div class='r-indent'>$1</div>");
            } else if (m = rows[i].match(/^　{2,9}/u)) {
                rows[i] = rows[i].replace(/^　{2,9}(.+)$/u, "<div class='indent char-"+m[0].length+"'>$1</div>");
            } else if (m = rows[i].match(/[−―−─—]{2,}/u)) {
                rows[i] = rows[i].replace(/([−―−─—]{2,})/ug, "<span class='dash'>$1</span>");
            }
        }
        string = rows.join("\n");
        string = string.replace(/<\/div>\n/g, "</div>");
        return string.replace(/\r\n|\r|\n/g, "<br/>");
    },
    ruby(string, append = "") {
        if (!string) return append;
        let ruby = this.wrap(string);
        // みてみん変換
        ruby = ruby.replace(/&lt;(i\d+)\|(\d+)&gt;/ug, "<img src='//$2.mitemin.net/userpageimage/viewimagebig/icode/$1' class='illustration'>");
        ruby = this._ruby(ruby);
        return ruby + append;
    },
    _ruby(string) {
        // 傍線変換
        string = string.replace(/[\(《]{2}/mug, "<em>").replace(/[\)》]{2}/mug, "</em>");
        // ルビ変換
        const regex = /([\|｜][^《]+|[\u3400-\u9FFF々]+)[《]([^》]+)[》]/mug;
        string = string.replace(regex, "<ruby>$1<rt>$2</rt></ruby>").replace(/[\|｜]/ug, "");
        // 半角句読点変換
        string = string.replace(/､/mug, "、").replace(/｡/mug, "。");
        return string;
    },
    url(string, ruby = false) {
        if (!string) return string;
        string = string.replace(/[&'`"<>]/g, function(match) {
            return {
                '&': '&amp;',
                "'": '&#x27;',
                '`': '&#x60;',
                '"': '&quot;',
                '<': '&lt;',
                '>': '&gt;',
            }[match]
        });
        string = string.replace(/\r\n|\r|\n/g, "<br/>");;
        const exp = new RegExp("((https?|ftp)(:\/\/[-_\.!~*\'\(\)a-zA-Z0-9;\/?:\@&=+\$,%#]+))", "g");
        let csrf = null;
        try {
            const meta = document.querySelector('meta[name="csrf-token"]');
            if (meta) {
                csrf = meta.getAttribute('content');
            }
        } catch (error) {
            console.error("トークン取得失敗");
        }
        string = string.replace(exp, (match) => {
            return `<a href="/jump?url=${match}&token=${csrf}" target="_blank">${match}</a>`;
        });
        if (ruby) {
            string = this._ruby(string);
        }
        return string;
    },
    truncate(string, length = 60) {
        if (string && string.length > length) {
            string = string.substring(0, length) + "...";
        }
        return string
    },
    initial(string, initial) {
        if (!string) {
            return initial;
        }
        return string;
    },
    editorTruncate(string, length = 350) {
        let strings = [];
        if (string) {
            try {
                const memo = JSON.parse(string);
                for (const block of memo.blocks) {
                    if (block.data.text) {
                        // 本文とヘッダ
                        strings.push(block.data.text);
                    } else if (block.data.items) {
                        // リスト
                        for (const item of block.data.items) {
                            strings.push(item);
                        }
                    } else if (block.data.content) {
                        for (const row of block.data.content) {
                            strings.push(row.join("\t"));
                        }
                    } else if (block.data.caption) {
                        strings.push(block.data.caption);
                    }
                }
            } catch (error) {
                strings = string.split("\n");
            }
        }
        if (length === 0) {
            return strings.join("<br>");
        }
        return this.truncate(strings.join("\n"), length).replace(/\n/g, "<br>");
    },
    jsonParse(string) {
        try {
            if (string && string.match(/^\{/)) {
                return JSON.parse(string);
            }
        } catch (error) {}
        return string;
    },
    getSize(data) {
        const len = encodeURI(data).replace(/%../g, "*").length;
        return this.getByte(len);
    },
    getByte(len) {
        if (len < 1024) {
            return this.numberFormat(len) + "B";
        } else if (len < (1024 * 1024)) {
            return this.numberFormat(Math.round(len / 1024)) + "KB";
        } else {
            if (Math.round(len / (1024 * 1024)) < 10) {
                return this.numberFormat(Math.round((len * 10) / (1024 * 1024)) / 10) + "MB";
            } else {
                return this.numberFormat(Math.round(len / (1024 * 1024))) + "MB";
            }
        }
    },
};
